module.exports = __webpack_public_path__ + "img/logo.f88d4be4.png";